// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-H5":"solarpanel_60w_solar-60w-H5__42K8y"};